(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function bindCartPage(section) {
      const form = section?.querySelector('#NoyocoCartPageForm');
      if (!form) return;

      const updateButton = form.querySelector('[data-cart-update]');

      form.querySelectorAll('[data-cart-quantity]').forEach(function (quantityControl) {
        const input = quantityControl.querySelector('input');
        const decrease = quantityControl.querySelector('[data-cart-decrease]');
        const increase = quantityControl.querySelector('[data-cart-increase]');

        decrease.addEventListener('click', function () {
          input.value = Math.max(0, Number(input.value) - 1);
          updateButton.click();
        });

        increase.addEventListener('click', function () {
          input.value = Number(input.value) + 1;
          updateButton.click();
        });

        input.addEventListener('change', function () {
          input.value = Math.max(0, Number(input.value) || 0);
          updateButton.click();
        });
      });

      let busy = false;
      form.querySelectorAll('[data-cart-remove]').forEach(function (link) {
        link.addEventListener('click', async function (event) {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (busy) return;
          busy = true;
          form.inert = true;
          section.setAttribute('aria-busy', 'true');
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 15000);

          try {
            const sectionId = section.dataset.cartSection;
            const response = await fetch(window.Shopify.routes.cart_change_url + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              signal: controller.signal,
              body: JSON.stringify({
                id: link.dataset.cartRemove,
                quantity: 0,
                sections: [sectionId],
                sections_url: window.location.pathname + window.location.search
              })
            });
            const cart = await response.json();
            if (!response.ok || !Array.isArray(cart.items)) throw new Error('cart-update');
            const html = cart.sections?.[sectionId];
            const nextSection = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.noyoco-cart-page');
            if (!nextSection) throw new Error('cart-render');
            window.Shopify.cart = cart;
            if (document.body._x_dataStack?.[0]) document.body._x_dataStack[0].cart = cart;
            section.replaceWith(nextSection);
            bindCartPage(nextSection);
            const heading = nextSection.querySelector('h1');
            heading?.setAttribute('tabindex', '-1');
            heading?.focus({ preventScroll: true });
          } catch (error) {
            const feedback = section.querySelector('[data-cart-page-error]');
            feedback.hidden = false;
            feedback.querySelector('a')?.focus({ preventScroll: true });
          } finally {
            clearTimeout(timeout);
            section.removeAttribute('aria-busy');
          }
        });
      });
    }

    bindCartPage(document.querySelector('.noyoco-cart-page'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noyoco-film-aw26"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noyoco-film')) {
    customElements.define('noyoco-film', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        this.mobile = matchMedia('(max-width:768px)');
        this.reduce = matchMedia('(prefers-reduced-motion:reduce)');
        this.userPaused = this.reduce.matches || Boolean(navigator.connection && navigator.connection.saveData);
        this.inView = true;
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.autoplay = !this.userPaused;
        this.syncState = () => {
          const playing = !this.video.paused && !this.video.ended;
          this.toggleAttribute('data-playing', playing);
          if (playing) this.setAttribute('data-loaded', '');
          this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
        };
        this.chooseSource = () => {
          const url = this.mobile.matches ? this.dataset.mobile : this.dataset.desktop;
          if (!url || this.video.getAttribute('src') === url) return;
          this.video.pause();
          this.removeAttribute('data-playing');
          this.removeAttribute('data-loaded');
          this.video.autoplay = !this.userPaused && this.inView && !document.hidden;
          this.video.src = url;
          this.video.load();
        };
        this.tryPlay = () => {
          if (this.userPaused || !this.inView || document.hidden) return;
          this.chooseSource();
          if (this.playAttempt || !this.video.paused) return;
          const attempt = this.video.play();
          if (!attempt) return;
          this.playAttempt = attempt;
          attempt.then(() => this.removeAttribute('data-autoplay-blocked'), error => {
            if (error.name === 'NotAllowedError') this.setAttribute('data-autoplay-blocked', '');
            this.syncState();
          }).finally(() => { if (this.playAttempt === attempt) this.playAttempt = null; });
        };
        this.togglePlayback = () => {
          this.userPaused = !this.video.paused;
          this.video.autoplay = !this.userPaused;
          if (this.userPaused) this.video.pause();
          else { this.playAttempt = null; this.tryPlay(); }
        };
        this.onResize = () => { if (this.video.hasAttribute('src')) this.chooseSource(); this.tryPlay(); };
        this.onMotion = () => { this.userPaused = this.reduce.matches; this.video.autoplay = !this.userPaused; if (this.userPaused) this.video.pause(); else this.tryPlay(); };
        this.onVisibility = () => { if (document.hidden) this.video.pause(); else this.tryPlay(); };
        this.onError = () => { this.removeAttribute('data-loaded'); this.syncState(); };
        this.video.addEventListener('canplay', this.tryPlay);
        this.video.addEventListener('playing', this.syncState);
        this.video.addEventListener('pause', this.syncState);
        this.video.addEventListener('error', this.onError);
        this.button.addEventListener('click', this.togglePlayback);
        this.mobile.addEventListener('change', this.onResize);
        this.reduce.addEventListener('change', this.onMotion);
        document.addEventListener('visibilitychange', this.onVisibility);
        window.addEventListener('pageshow', this.onVisibility);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (this.inView) this.tryPlay(); else this.video.pause();
        }, {threshold: .05});
        this.observer.observe(this);
        this.tryPlay();
        this.button.hidden = !(this.dataset.desktop || this.dataset.mobile);
        this.syncState();
      }
      disconnectedCallback() {
        if (!this.ready) return;
        this.video.pause();
        this.observer.disconnect();
        this.video.removeEventListener('canplay', this.tryPlay);
        this.video.removeEventListener('playing', this.syncState);
        this.video.removeEventListener('pause', this.syncState);
        this.video.removeEventListener('error', this.onError);
        this.button.removeEventListener('click', this.togglePlayback);
        this.mobile.removeEventListener('change', this.onResize);
        this.reduce.removeEventListener('change', this.onMotion);
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.removeEventListener('pageshow', this.onVisibility);
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noyoco-lookbook-aw26"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseLookbook = (scope = document) => {
      scope.querySelectorAll('[data-aw26-product-trigger]').forEach((trigger) => {
        if (trigger.dataset.aw26Bound === 'true') return;
        trigger.dataset.aw26Bound = 'true';
        trigger.addEventListener('click', () => {
          const dialog = document.getElementById(trigger.dataset.aw26ProductTrigger);
          if (dialog && !dialog.open) dialog.showModal();
        });
      });

      scope.querySelectorAll('[data-aw26-product-dialog]').forEach((dialog) => {
        if (dialog.dataset.aw26Bound === 'true') return;
        dialog.dataset.aw26Bound = 'true';
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });
    };

    initialiseLookbook();
    document.addEventListener('shopify:section:load', (event) => initialiseLookbook(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
